export const COLLECTIVE = {
  hero: {
    kicker: "Black Anchor Collective",
    title: "Coming Soon",
    tagline: "Not a membership. A mark of ownership.",
    intro: "A private community built for those who take pride in what they own.",
    image:
      "https://images.unsplash.com/photo-1780342679194-fba7348d089b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB5YWNodCUyMG5pZ2h0JTIwZHJhbWF0aWMlMjBkYXJrJTIwd2F0ZXJ8ZW58MHx8fHwxNzg2NTczMDgyfDA&ixlib=rb-4.1.0&q=85",
  },

  chapters: [
    {
      num: "01",
      title: "A mark, not a tier",
      body:
        "The Collective isn't a loyalty program. It's a circle — of owners who care about the machines they keep and the standard they hold them to. Boats first. Then cars, and everything else worth protecting.",
    },
    {
      num: "02",
      title: "Built around the anchor",
      body:
        "Black Anchor's craft is the backbone: priority detailing, ceramic inspections, concierge scheduling, first access to what we make. Membership turns service into relationship.",
    },
    {
      num: "03",
      title: "Your machine becomes the brand",
      body:
        "Instead of another boat we detailed, you'll see the people and machines inside the Collective — filmed, photographed and profiled. Membership becomes something people want to be associated with.",
    },
  ],

  foundingBenefits: [
    "A permanent Founding Fleet number, #001–#100",
    "The numbered metal boat plaque",
    "Matte-black membership card & challenge coin",
    "Founder-only apparel — retired forever",
    "Permanent recognition on Black Anchor",
    "Lifetime Founder status",
  ],

  experiences: [
    { name: "The Black Anchor Rendezvous", note: "The annual invitational — boats and cars, on the water and under lights." },
    { name: "Private cruises & dinners", note: "Intimate gatherings for members only." },
    { name: "Cars & Coffee", note: "Morning meetups for the machines between the boats." },
    { name: "Product launches & drops", note: "First look at limited Black Anchor releases." },
  ],

  memberFleet: {
    label: "Black Anchor Collective // Member #017",
    machine: "42′ MTI",
    spec: "Twin Mercury Racing 500Rs",
    image:
      "https://images.unsplash.com/photo-1568476612160-787b6a1d5fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzcGVlZGJvYXQlMjBwb3dlcmJvYXQlMjBvbiUyMHdhdGVyfGVufDB8fHx8MTc4NjU2NjE1Mnww&ixlib=rb-4.1.0&q=85",
  },

  ecosystem: ["Marine", "Automotive", "RV & Powersports", "Aviation", "Collector Assets"],
  subBrands: ["Black Anchor Supply", "Black Anchor Academy", "Black Anchor Concierge", "The Invitational"],

  beyond:
    "The Collective grows beyond the original hundred through further levels — without ever diluting the significance of the first. At the summit: the Elite, a handful of machines that represent Black Anchor at its highest, and a select ambassador circle.",
};

export const MEMBER_FLEET = [
  {
    number: "017",
    machine: "42′ MTI",
    spec: "Twin Mercury Racing 500Rs",
    image:
      "https://images.unsplash.com/photo-1568476612160-787b6a1d5fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzcGVlZGJvYXQlMjBwb3dlcmJvYXQlMjBvbiUyMHdhdGVyfGVufDB8fHx8MTc4NjU2NjE1Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    number: "003",
    machine: "38′ Performance Hull",
    spec: "Show-finish gelcoat restoration",
    image:
      "https://images.unsplash.com/photo-1758724803399-bab6108b596b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxib2F0JTIwZGV0YWlsaW5nJTIwcG9saXNoaW5nJTIwaHVsbCUyMGNsb3NldXB8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    number: "042",
    machine: "Wake / Tower Boat",
    spec: "Ceramic-coated, tower to keel",
    image:
      "https://images.unsplash.com/photo-1729475003631-118f0aee787d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxib2F0JTIwZGV0YWlsaW5nJTIwcG9saXNoaW5nJTIwaHVsbCUyMGNsb3NldXB8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
  },
];
